import { render, staticRenderFns } from "./StakeholderListView.vue?vue&type=template&id=ce78f1d0&scoped=true"
import script from "./StakeholderListView.vue?vue&type=script&lang=js"
export * from "./StakeholderListView.vue?vue&type=script&lang=js"
import style0 from "./StakeholderListView.vue?vue&type=style&index=0&id=ce78f1d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce78f1d0",
  null
  
)

export default component.exports